export default "__VITE_ASSET__164416fb__"